import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/collapse';

document.addEventListener('DOMContentLoaded', () => {
    $('body').tooltip({ selector: '[data-toggle=tooltip]' });
});
